/* eslint-disable react-hooks/exhaustive-deps */
import "./App.css";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import { useEffect, useState } from "react";
import { requestWithHeaders } from "./api/requestMethods";
import { io } from "socket.io-client";
import debounce from "./utils/debounce";
import { useNavigate } from "react-router-dom";
import UpdateCompletionNotesComponent from "./components/UpdateCompletionNotesComponent";

function App() {
  const socket = io(process.env.REACT_APP_WEBSOCKET_URL, {
    withCredentials: true, // Allows sending credentials such as cookies
    transports: ["websocket"],
    autoConnect: true,
  });
  const [modal, setModal] = useState(false);
  const [paginationData, setPaginationData] = useState(null);
  const [modalData, setModalData] = useState({});
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const limit = 10;
  const navigate = useNavigate();
  const [managedLocket, setManagedLocket] = useState("");
  const [utteranceLoading, setUtteranceLoading] = useState(false);
  const [lockets, setLockets] = useState([]);

  const service_types = [
    { service_type: 1, name: "Mahasiswa" },
    { service_type: 2, name: "Calon Mahasiswa" },
    { service_type: 3, name: "Dosen" },
    { service_type: 4, name: "Tenaga Pendidik" },
    { service_type: 5, name: "Masyarakat" },
    { service_type: 6, name: "Alumni" },
  ];

  const fetchData = async ({ resetPage = true }) => {
    if (managedLocket === "") return;
    if (resetPage && page !== 1) {
      setPage(1);
    }
    try {
      const res = await requestWithHeaders.get(
        `/api/admin/locket-${managedLocket}?status=active&page=${page}&limit=${limit}`
      );
      if (res?.data?.status) {
        setLockets(() => res?.data?.data);
        setPaginationData(() => res?.data?.pagination);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const debouncedFetchData = debounce(
    () => fetchData({ resetPage: true }),
    300
  );

  const toggleModal = (locket) => {
    setModal(!modal);
    setModalData(locket);
  };

  const changeStatus = async (id, status) => {
    setLoading(true);
    try {
      await requestWithHeaders.post(`/api/admin/change-status`, {
        id,
        status,
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (page === 1) {
        debouncedFetchData();
      }
    }
  };

  const speak = (ticketNumber = "") => {
    // Mengecek apakah browser mendukung SpeechSynthesis

    if ("speechSynthesis" in window) {
      const utterance = new SpeechSynthesisUtterance(
        `nomor antrian ${ticketNumber} silahkan menuju loket.`
      );
      utterance.onstart = () => {
        setUtteranceLoading(true); // Start loading when speech begins
      };
      utterance.onend = () => {
        setUtteranceLoading(false); // Start loading when speech begins
      };
      utterance.lang = "id-ID"; // Set bahasa ke Indonesia
      utterance.rate = 0.6; // Set tingkat kecerdasan suara
      window.speechSynthesis.speak(utterance);
      setTimeout(() => {
        window.speechSynthesis.speak(utterance);
      }, 1000);
    } else {
      console.log("Browser Anda tidak mendukung Text-to-Speech.");
      alert("Browser Anda tidak mendukung Text-to-Speech.");
    }
  };

  const reconnectSocket = () => {
    setTimeout(socket.connect(), 200);
  };

  const initManagedLocket = async () => {
    try {
      const userLocket = await requestWithHeaders.get("api/user/profile");
      setManagedLocket(() => userLocket?.data?.data?.managed_locket);
    } catch (error) {
      if (
        error.response?.data?.message === "Token Expired!" ||
        error.response?.data?.message === "Authentication Failed!"
      ) {
        localStorage.removeItem("token");
        navigate("/login");
        return;
      }
    }
  };

  const initSocket = async () => {
    socket.on("connect", () => {
      console.log("Connected to websocket");
      debouncedFetchData();
    });

    if (managedLocket === "a") {
      socket.on("update-locket-a", () => {
        console.log("update-locket-a");
        debouncedFetchData();
      });
    }

    if (managedLocket === "b") {
      socket.on("update-locket-b", () => {
        console.log("update-locket-b");
        debouncedFetchData();
      });
    }

    if (managedLocket === "c") {
      socket.on("update-locket-c", () => {
        console.log("update-locket-c");
        debouncedFetchData();
      });
    }

    socket.on("disconnect", (event) => {
      socket.close();
      if (event !== "io client disconnect") {
        reconnectSocket();
      }
    });
    socket.on("error", (error) => {
      socket.disconnect();
      reconnectSocket();
    });
    socket.connect();
  };

  useEffect(() => {
    initManagedLocket();
  }, []);

  useEffect(() => {
    if (managedLocket === "") return;
    initSocket();
  }, [managedLocket]);

  useEffect(() => {
    fetchData({ resetPage: false });
  }, [page]);

  const pageButtons = [];
  for (let index = 1; index <= paginationData?.totalPages; index++) {
    pageButtons.push(
      <li key={index} className="page-item">
        <button
          className={`page-link ${modal ? "modal-open-handler" : ""}`}
          onClick={() => {
            setPage(index);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          {index}
        </button>
      </li>
    );
  }

  return (
    <div>
      <Topbar />
      <div className="row">
        <div className="col-md-2">
          <Sidebar />
        </div>
        <div
          className="col-md-10"
          style={{ marginLeft: "250px", paddingTop: "70px" }}
        >
          <div className="row px-5 ">
            <div className="col-xl-4 col-md-4 mt-4">
              <div className="card shadow h-100 py-2 pl-3">
                <div className="card-body pt-2 pr-3">
                  <div className="row align-items-center">
                    <div className="col-md-4 d-flex justify-content-center">
                      <img src="/images/vector-.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <div
                        className="row fs-6 card-number"
                        style={{ color: "#247957" }}
                      >
                        {paginationData?.totalItems || 0}
                      </div>
                      <div className="row fs-6">Jumlah Antrian Aktif</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 mt-4">
              <div className="card shadow h-100 py-2 pl-3">
                <div className="card-body pt-2 pr-3">
                  <div className="row align-items-center">
                    <div className="col-md-4 d-flex justify-content-center">
                      <img src="/images/vector-1.png" alt="vector" />
                    </div>
                    <div className="col-md-8">
                      <div
                        className="row card-number"
                        style={{ color: "#2E90FA" }}
                      >
                        {paginationData?.upcomingLocket &&
                        paginationData?.upcomingLocket?.length > 0
                          ? paginationData?.upcomingLocket[0].ticket_number
                          : "---"}
                      </div>
                      <div className="row">Antrian Sekarang</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 mt-4">
              <div className="card shadow h-100 py-2 pl-3">
                <div className="card-body pt-2 pr-3">
                  <div className="row align-items-center">
                    <div className="col-md-4 d-flex justify-content-center">
                      <img src="/images/vector-2.png" alt="vector" />
                    </div>
                    <div className="col-md-8">
                      <div
                        className="row fs-6 card-number"
                        style={{ color: "#EFC02E" }}
                      >
                        {paginationData?.upcomingLocket &&
                        paginationData?.upcomingLocket?.length > 1
                          ? paginationData?.upcomingLocket[1].ticket_number
                          : "---"}
                      </div>
                      <div className="row fs-6">Antrian Selanjutnya</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row px-5 mt-5">
            <div className="card shadow h-100 py-2 pl-3">
              <div className="card-body pt-2 pr-3">
                <div className="row mx-3 mt-3">
                  <table className="table table-striped table-bordered align-middle">
                    <thead>
                      <tr>
                        <th scope="col">
                          <div className="d-flex align-items-center justify-content-center">
                            Nomor Antrian
                          </div>
                        </th>
                        <th scope="col">
                          <div className="d-flex align-items-center justify-content-center">
                            Data Diri
                          </div>
                        </th>
                        <th scope="col">
                          <div className="d-flex align-items-center justify-content-center">
                            Panggil
                          </div>
                        </th>
                        <th scope="col">
                          <div className="d-flex align-items-center justify-content-center">
                            Detail
                          </div>
                        </th>
                        <th scope="col">
                          <div className="d-flex align-items-center justify-content-center">
                            Action
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {lockets?.length === 0 && (
                        <>
                          <tr>
                            <td colSpan={5}>
                              <div className="img-bg">
                                <div>
                                  <img
                                    className="row"
                                    src="images/not-found.png"
                                    alt="Not Found"
                                  />
                                  <p className="mt-1 nf-text">
                                    Belum ada antrian aktif
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </>
                      )}
                      {lockets?.map((locket, i) => (
                        <tr key={i}>
                          <td>
                            <div className="d-flex align-items-center justify-content-center m-3 td-data">
                              {locket?.ticket_number}
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center m-1 flex-column td-data">
                              <div
                                className="mb-1 mt-3"
                                style={{ fontWeight: 700, textAlign: "center" }}
                              >
                                {locket?.user?.fullname}
                              </div>
                              <div
                                className="mb-1"
                                style={{ textAlign: "center" }}
                              >
                                {locket?.service_name}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center m-3 td-data">
                              <button
                                className="btn p-2 d-flex align-items-center"
                                style={{ backgroundColor: "#247957" }}
                                disabled={
                                  page === 1 &&
                                  i === 0 &&
                                  locket?.status !== 3 &&
                                  !loading &&
                                  !utteranceLoading
                                    ? false
                                    : true
                                }
                                onClick={() => {
                                  changeStatus(locket?.id, 2);
                                  speak(locket?.ticket_number);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="white"
                                  className="bi bi-mic-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0z" />
                                  <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5" />
                                </svg>
                              </button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center m-3 td-data">
                              <button
                                className="btn button-custom-text btn-outline-info"
                                onClick={() => toggleModal(locket)}
                              >
                                <span
                                  style={{
                                    color: "#53B1FD",
                                    fontSize: 16,
                                    fontWeight: 700,
                                  }}
                                >
                                  Lihat
                                </span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="#53B1FD"
                                  className="bi bi-file-earmark-text ml-2 mb-1"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5" />
                                  <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                                </svg>
                              </button>
                              {modal && (
                                <div className="modal-custom">
                                  <div
                                    onClick={toggleModal}
                                    className="overlay"
                                  ></div>
                                  <div className="modal-content p-5">
                                    <div className="row mt-5">
                                      <div className="col mt-1 mr-3">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Nama Pengunjung
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Nama"
                                            aria-label="Nama"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user?.fullname
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col mt-1">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Fakultas/SatKer
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Fakultas"
                                            aria-label="Fakultas"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user?.faculty
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col mr-3">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          NIM/NIP
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="NIM/NIP"
                                            aria-label="NIM/NIP"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user?.nim_nip
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Status Pengunjung
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Status"
                                            aria-label="Status"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user?.user_status
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Jenis Layanan
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Jenis Layanan"
                                            aria-label="Jenis Layanan"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              service_types?.[
                                                modalData?.service_type - 1
                                              ]?.name
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Layanan yang Dibutuhkan
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Layanan yang Dibutuhkan"
                                            aria-label="Layanan yang Dibutuhkan"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.service_name
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Pertanyaan/Keluhan Singkat
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Pertanyaan/Keluhan Singkat"
                                            aria-label="Pertanyaan/Keluhan Singkat"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={modalData?.complaint}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row my-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Catatan Akhir Pelayanan
                                        </div>
                                        <UpdateCompletionNotesComponent
                                          modalData={modalData}
                                          toggleModal={toggleModal}
                                        />
                                      </div>
                                    </div>
                                    <button
                                      className="close-modal"
                                      onClick={toggleModal}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="black"
                                        className="bi bi-x-lg"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                      </svg>
                                    </button>
                                    <div className="modal-footer" />
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center m-3">
                              <button
                                className="btn btn-success ml-1 mr-3"
                                disabled={
                                  page === 1 &&
                                  i === 0 &&
                                  (locket?.status === 3 ||
                                    locket?.status === 2) &&
                                  !utteranceLoading
                                    ? false
                                    : true
                                }
                                onClick={() => {
                                  if (locket?.status !== 3) {
                                    changeStatus(locket?.id, 3);
                                  }
                                  toggleModal(locket);
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <span
                                    style={{
                                      color: "white",
                                      fontSize: 12,
                                      fontWeight: 700,
                                    }}
                                    className="mr-1"
                                  >
                                    Layani
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="white"
                                    className="bi bi-x-lg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                  </svg>
                                </div>
                              </button>
                              <button
                                className="btn btn-primary mr-1"
                                disabled={
                                  page === 1 &&
                                  i === 0 &&
                                  locket?.status === 3 &&
                                  !utteranceLoading
                                    ? false
                                    : true
                                }
                                onClick={() => changeStatus(locket?.id, 4)}
                              >
                                <div className="d-flex align-items-center">
                                  <span
                                    style={{
                                      color: "white",
                                      fontSize: 12,
                                      fontWeight: 700,
                                    }}
                                    className="mr-1"
                                  >
                                    Selesai
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="white"
                                    className="bi bi-check2"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                  </svg>
                                </div>
                              </button>
                            </div>
                            <div className="d-flex align-items-center justify-content-center m-3">
                              <button
                                className="btn btn-danger mr-3"
                                disabled={
                                  page === 1 &&
                                  i === 0 &&
                                  locket?.status !== 3 &&
                                  !utteranceLoading
                                    ? false
                                    : true
                                }
                                onClick={() => changeStatus(locket?.id, 10)}
                              >
                                <div className="d-flex align-items-center">
                                  <span
                                    style={{
                                      color: "white",
                                      fontSize: 12,
                                      fontWeight: 700,
                                    }}
                                    className="mr-1"
                                  >
                                    Lewati
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="white"
                                    className="bi bi-x-lg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                  </svg>
                                </div>
                              </button>

                              <button
                                className="btn btn-danger mr-1"
                                disabled={
                                  page === 1 &&
                                  i === 0 &&
                                  locket?.status !== 3 &&
                                  !utteranceLoading
                                    ? false
                                    : true
                                }
                                onClick={() => changeStatus(locket?.id, 11)}
                              >
                                <div className="d-flex align-items-center">
                                  <span
                                    style={{
                                      color: "white",
                                      fontSize: 12,
                                      fontWeight: 700,
                                    }}
                                    className="mr-1"
                                  >
                                    Tidak bisa dilayani
                                  </span>
                                </div>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="row d-flex my-3 mx-3 justify-content-between align-items-center">
                  <div>
                    Menampilkan{" "}
                    {(paginationData?.page - 1) * paginationData?.limit +
                      lockets?.length || 0}{" "}
                    dari {paginationData?.totalItems || 0} antrian aktif
                  </div>
                  <nav
                    aria-label="Page navigation example"
                    className="align-items-center"
                  >
                    <ul className="pagination">
                      <li className="page-item">
                        <button
                          className={`page-link ${
                            modal ? "modal-open-handler" : ""
                          }`}
                          aria-label="Previous"
                          disabled={paginationData?.page === 1 ? true : false}
                          onClick={() => {
                            setPage(page - 1);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>
                      {pageButtons}
                      {/* <li className="page-item">
                        <button
                          className={`page-link ${
                            modal ? "modal-open-handler" : ""
                          }`}
                          onClick={() => setPage(2)}
                        >
                          2
                        </button>
                      </li> */}
                      <li className="page-item">
                        <button
                          className={`page-link ${
                            modal ? "modal-open-handler" : ""
                          }`}
                          href="/#"
                          aria-label="Next"
                          disabled={
                            paginationData?.page === paginationData?.totalPages
                          }
                          onClick={() => {
                            setPage(page + 1);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
